"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureDetection = void 0;
const slice_1 = require("../store/slices/feature-flags/slice");
const store_day1_1 = require("../store/store-day1");
const react_1 = require("react");
function useFeatureDetection(overrides = null) {
    (0, react_1.useEffect)(() => {
        const onlyAssistedInstallerFeatures = Object.fromEntries(Object.entries(overrides !== null && overrides !== void 0 ? overrides : {}).filter(([k, _v]) => k.startsWith('ASSISTED_INSTALLER')));
        void store_day1_1.storeDay1.dispatch(slice_1.featureFlagsAsyncActions.detectFeaturesAsync(onlyAssistedInstallerFeatures));
    }, [overrides]);
}
exports.useFeatureDetection = useFeatureDetection;
//# sourceMappingURL=use-feature-detection.js.map